export const SquareIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 15 15" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M1 1h13v13H1V1Zm1 1v11h11V2H2Z" />
  </svg>
)
